import { Paper, TextField, Button} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState } from "react";
import {DataGrid} from "@mui/x-data-grid";
import { searchCustomersbyNumber, searchCustomersbymail } from "../api/customerapi";
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";


const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(60),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    headertext: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(3),
    },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: theme.spacing(18),
        height: theme.spacing(5),
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(1),
        fontSize: 14
      },
      
  }));

const Searchcust = () => {

    const classes = useStyles();

    const width = window.innerWidth-200;
//console.log(width);
const columns = [
  { field: 'cust_id', 
  headerName: ' Cust ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
  {
    field: 'cust_name',
    headerName: 'Name',
    width: width/12*4,
    
  },
  {
    field: 'primary_mobile_number',
    headerName: 'Primary Mobile',
    width: width/12,
  },
  {
    field: 'primary_email_id',
    headerName: 'Email Id',
    width: width/12*2,
  },
  {
    field: 'chat_mobile_number',
    headerName: 'Chat Number',
    width: width/12,
  },
  {
    field: 'trip_status',
    headerName: 'Active Trips',
    width: width/12*3,
        /*valueGetter: (params) =>
      `${params.getValue(params.id, 'firstName') || ''} ${
        params.getValue(params.id, 'lastName') || ''
      }`,*/
  },
];

    const [searchData, setsearchData]=useState([{
        
    }]);

    const [listcustData, setlistcustData]=useState([{
        cust_name: "",
        primary_mobile_number: undefined,
        chat_mobile_number: undefined,
        secondary_mobile_numbers: "",
        only_chat: false,
        marketing_message: true,
        cust_ref: "",
        cust_notes: "",
        cust_channel: "",
        primary_email_id: "",
        secondary_email_ids: "",
        cust_city: "",
        cust_state: "",
        cust_createdBy: "",
        cust_trips:[{
        id: undefined,
        status: ""
        }],
      }]);   
      const { appData, loading } = useAppData();
      var {cuser, role}=GetRole();
      const handleSearch = async (e) => {
        try{
          //console.log(searchData.data)
        const data = await searchCustomersbyNumber(searchData.data);
        //console.log(data.data)
        setlistcustData(data.data)
      }catch(err){
        console.log(err)
      }
      }

      const handleSearch2 = async (e) => {
        try{        //console.log(searchData.data)
      const data = await searchCustomersbymail(searchData.email);
      //console.log(data.data)
      setlistcustData(data.data)
    }catch(err){
      console.log(err)
    }
    }

      const custdatalistdisplay=listcustData.map(custdata=>({cust_name: custdata.cust_name, 
        id:listcustData.indexOf(custdata), 
        cust_id:custdata.cust_id, 
        primary_mobile_number:custdata.primary_mobile_number, 
        primary_email_id:custdata.primary_email_id,
        chat_mobile_number:custdata.chat_mobile_number, 
        trip_status: custdata.cust_trips.map(trip => trip.id)}))

        const gridcellclick=(id)=>{
            window.location = ("/custdataentry/"+id);
            //console.log("/custdataentry/"+id);
          }

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>        
           
        <div align="center">
            <TextField variant="standard"  label="Enter primary number"  InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setsearchData({...searchData, data: e.target.value})}/>
            <Button onClick={handleSearch} color="secondary" variant="contained" className={classes.button}>Search</Button>
            <TextField variant="standard"  label="Enter email"  InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setsearchData({...searchData, email: e.target.value})}/>
            <Button onClick={handleSearch2} color="secondary" variant="contained" className={classes.button}>Search</Button>
            {role=="Admin" || role=="Marketing" || role=="Operations" || role=="Operations-TL"?(
              <Button href="/listcustdata" color="primary" variant="contained" className={classes.button}>View Customers</Button>
            ):("")}
            
        </div>    
        {custdatalistdisplay.length >0 ?
        <div style={{ height: 1200, width: '100%' }}>
        <DataGrid rows={custdatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.cust_id)}
        columns={columns}
        // pageSize={20}
        autoPageSize
        // autoHeight
        >      
      </DataGrid>      
    </div>  :
    <div align="center"><h1>No data found</h1></div>    }
    </Paper>
     );
}
 
export default Searchcust;